import { buildLoader } from '../util/GenericLoader';
import {
  getStagingDevicesAction,
  getStagingEquipmentAction,
  getStagingPointsAction,
  getStagingEquipmentValidationAction,
  getStagingPointsValidationAction,
} from '../../redux/actions/staging';

export const StagingDevicesLoader = buildLoader(getStagingDevicesAction);

export const StagingEquipmentLoader = buildLoader(getStagingEquipmentAction);
export const StagingPointsLoader = buildLoader(getStagingPointsAction);

export const StagingEquipmentValidationLoader = buildLoader(getStagingEquipmentValidationAction);
export const StagingPointsValidationLoader = buildLoader(getStagingPointsValidationAction);
